import API from './api'

export async function createTag(token, data) {
  let response
  try {
    response = await API.post(`tag/`, data, {
      headers: { Authorization: `token ${token}` },
    })
  } catch (error) {
    response = error.response
  }
  return response
}

export async function updateTag(photographerUID, token, identifier, data) {
  let response
  try {
    response = await API.patch(`tag/${identifier}/`, data, {
      headers: { Authorization: `token ${token}` },
    })
  } catch (error) {
    response = error.response
  }
  return response
}

export async function deleteTag(token, identifier) {
  let response
  try {
    response = await API.delete(`tag/${identifier}`, {
      headers: { Authorization: `token ${token}` },
    })
  } catch (error) {
    response = error.response
  }
  return response
}

export async function createPriorityTag(token, data) {
  let response
  try {
    response = await API.post(`priority-tag/`, data, {
      headers: { Authorization: `token ${token}` },
    })
  } catch (error) {
    response = error.response
  }
  return response
}

export async function deletePriorityTag(token, identifier) {
  let response
  try {
    response = await API.delete(`priority-tag/${identifier}`, {
      headers: { Authorization: `token ${token}` },
    })
  } catch (error) {
    response = error.response
  }
  return response
}

export async function updateSortedPriorityTags(token, data) {
  let response
  try {
    response = await API.post(`reorder-priority-tag/`, data, {
      headers: { Authorization: `token ${token}` },
    })
  } catch (error) {
    response = error.response
  }
  return response
}
